import { AdaptationView, adaptationViewOptions } from './index'
import ClimateSegmentedField from './ClimateSegmentedField'

type AdaptationViewSelectorProps = {
  value: AdaptationView
  onChange: (view: AdaptationView) => void
  label?: string
  disabled?: boolean
  adaptedDisabled?: boolean
  adaptedDisabledTooltip?: string
  helpText?: string
}

const DEFAULT_HELP_TEXT =
  'Raw shows unadapted results; Adapted shows results after attached adaptations are applied.'

const AdaptationViewSelector = ({
  value,
  onChange,
  label = 'Adaptations',
  disabled = false,
  adaptedDisabled = false,
  adaptedDisabledTooltip = 'No adaptations are attached.',
  helpText = DEFAULT_HELP_TEXT,
}: AdaptationViewSelectorProps) => {
  return (
    <ClimateSegmentedField
      label={label}
      helpText={helpText}
      value={value}
      onChange={next => onChange(next as AdaptationView)}
      options={adaptationViewOptions.map(option => ({
        value: option.value,
        label: option.label,
        disabled: option.value === 'effective' ? adaptedDisabled : false,
        disabledTooltip: option.value === 'effective' && adaptedDisabled ? adaptedDisabledTooltip : undefined,
      }))}
      disabled={disabled}
      ariaLabel="Adaptation view"
    />
  )
}

export default AdaptationViewSelector
